export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/threshold/sturges.js
// module id = 783
// module chunks = 0